import React from 'react'
import PropTypes from 'prop-types'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div ref={this.props.setWrapperRef} id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <p>I'm an engineering lead at Homebase, focused on delivering reliable, scalable systems for Data and ML/AI teams and platforms.</p>
          <p>Over the past decade, I've worked across full-stack product development, distributed backend systems, and data engineering. My recent work includes building AI and agentic platforms that enable Product and Applied AI teams to deploy features at scale, alongside dependable ETL pipelines and data infrastructure built with technologies such as Kafka, Airflow, Redshift, Snowflake, Databricks, Python, and AWS.</p>
          <p>I especially enjoy designing and standing up new systems with monitoring, alerting, and clear success metrics in place from the start—making them reliable for their users without sacrificing the sanity of the engineering teams that own them.</p>
          <p>I'm a University of Ottawa Computer Science graduate and recipient of the Faculty of Engineering Plaque for the highest GPA in my discipline, as well as the Governor General's Academic Bronze Medal. Away from the keyboard, you'll usually find me golfing, fishing, or building something in the wood shop.</p>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
